export default __webpack_public_path__ + "static/media/fad-sliderhandle-1.c302503a.svg";